import React from 'react';
import {Link} from "react-router-dom";
import {clsx} from "clsx";

function IconButtonLink({children, href, disabled}) {
	return (
		<Link 
			to={disabled ? '#' : (href || '#')}
			onClick={e => disabled && e.preventDefault()}
			className={clsx(
				"flex items-center justify-center px-2 py-2 text-lg leading-tight bg-gray-200 hover:bg-blue-100 rounded-full shadow-md transform transition-all duration-200 ease-in-out hover:translate-y-[-2px] hover:shadow-lg hover:shadow-blue-100 active:translate-y-[1px] active:shadow-sm border-b-2 border-gray-300",
				disabled && "bg-gradient-to-br from-gray-400 to-gray-600 border-gray-500 cursor-not-allowed hover:translate-y-0 hover:shadow-md"
			)}>
			{children}
		</Link>
	);
}

export default IconButtonLink;
